import Logo from '../assets/images/gopay-icon.svg'
import TselLogo from '../assets/images/tsel-logo.png'

export const updateMetaConfig = () => {
    const GopayConfig = {
        title: 'GoPay',
        icon: Logo,
        appleTouchIcon: Logo,
        description: 'Gopay Web Client',
    }

    const TselConfig = {
        title: 'Telkomsel Wallet',
        icon: TselLogo,
        appleTouchIcon: TselLogo,
        description: 'Telkomsel Wallet',
    }

    const metaConfig = window.location.pathname.startsWith('/user/')
        ? TselConfig
        : GopayConfig

    document.title = metaConfig.title

    const updateLink = (rel: string, href: string) => {
        let link = document.querySelector(
            `link[rel='${rel}']`
        ) as HTMLLinkElement
        if (!link) {
            link = document.createElement('link')
            link.setAttribute('rel', rel)
            document.head.appendChild(link)
        }
        link.setAttribute('href', href)
    }

    updateLink('icon', metaConfig.icon)
    updateLink('apple-touch-icon', metaConfig.appleTouchIcon)

    let metaDescription = document.querySelector(
        "meta[name='description']"
    ) as HTMLMetaElement
    if (!metaDescription) {
        metaDescription = document.createElement('meta')
        metaDescription.setAttribute('name', 'description')
        document.head.appendChild(metaDescription)
    }
    metaDescription.setAttribute('content', metaConfig.description)
}
